import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b9ccc66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Sign in with Google")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "googleSignIn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.socialLogin && $options.socialLogin(...args)))
    }, [
      _createElementVNode("img", {
        src: require('@/assets/google.jpg'),
        width: "50",
        height: "50"
      }, null, 8, _hoisted_2),
      _hoisted_3
    ])
  ]))
}